import { apolloClient } from '~/apollo-client';
import {
  Flex_UploadBillImageMutation,
  Flex_UploadBillImageMutationVariables,
} from '~/typings/graphql';
import { UPLOAD_BILL_IMAGE } from './upload-bill-image.queries';

export type UploadBillImageParams = {
  accountId: number;
  base64Image: string;
  utilityAccountId?: number;
};

export type UploadBillImageResponse = {
  uploadId: number;
};

export const uploadBillImage = async ({
  accountId,
  base64Image,
  utilityAccountId,
}: UploadBillImageParams): Promise<UploadBillImageResponse> => {
  const response = await apolloClient.mutate<
    Flex_UploadBillImageMutation,
    Flex_UploadBillImageMutationVariables
  >({
    mutation: UPLOAD_BILL_IMAGE,
    variables: { input: { image: base64Image, accountId, utilityAccountId } },
  });
  return { uploadId: response.data?.uploadBillImage.id! };
};
